module.exports = __webpack_public_path__ + "static/media/pillowfort.d2c5c5ab.svg";